import * as mobxReact from 'mobx-react';
import React from 'react';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { ConfigurePassportPreviewPresentation } from '../../configure-passport-display/configure-passport-preview/configure-passport-preview-presentation';
import { PASSPORT_CONFIGURATION_OTHER_CONNECTIONS } from '../../configure-passport-display/configure-passport-display.config';
import { ConnectionGroupsPassportPreviewViewModel } from './connection-group-passport-preview.viewmodel';
import Spinner from '../../../../../global/spinner/spinner';

interface IConnectionGroupsPassportPreviewModalProps {
    vm: ConnectionGroupsPassportPreviewViewModel;
}

interface IBodyProps {
    vm: ConnectionGroupsPassportPreviewViewModel;
}

const ModalBody = mobxReact.observer(
    (props: IBodyProps) => {
        const { vm } = props;
        return vm.getIsLoading()
            ? (<Spinner />)
            : (
                <>
                    {vm.getConnectionGroupsForPreview().map((item, index) => {
                        const audioBridgeValues = {
                            showDialInInfo: item.showDialInInfo,
                            hideDialInInfo: item.hideDialInInfo,
                            showHideButtonEnabled: item.showHideButtonEnabled
                        };

                        return <ConfigurePassportPreviewPresentation
                            key={index}
                            passportLabel={item.passportLabel}
                            formVM={vm.getAbstractFormViewModelController(item.connection)}
                            passportDescription={item.passportDescription}
                            connection={item.connection}
                            otherConnections={PASSPORT_CONFIGURATION_OTHER_CONNECTIONS.includes(item.connection.type )}
                            connectButtonLabel={item.connectButtonLabel}
                            connectionDetailsEnabled={item.connectionDetailsEnabled}
                            phoneNumbersSet={item.phoneNumberSet}
                            passportConfigurationMode={vm.passportConfigurationMode}
                            connectionType={item.connection.type}
                            audioBridgeValues={audioBridgeValues}
                            isConnectionGroup
                        />;
                    })}
                </>
            );
    }
);

const ConnectionGroupPassportPreviewPopover = mobxReact.observer((props: IConnectionGroupsPassportPreviewModalProps) => {
    const {
        vm,
    } = props;

    return (
        <CommonModal
            title={vm.getPopoverTitle()}
            isOpen={vm.getIsPopoverOpen()}
            onRequestClose={vm.closePopover}
            className='passport-preview-popover'

        >
            <ModalBody
                vm={vm}
            />
        </CommonModal>
    );
});

export { ConnectionGroupPassportPreviewPopover };
